import { useEffect } from 'react';
import { X } from '@hungryroot/icons';
import { TransparentButton, Heading, Paragraph } from '@hungryroot/ramen';
import styles from './ThankYouStage.module.css';
import sharedStyles from '../shared.module.css';

export function ThankYouStage(props: {
  dismissModal: () => void;
  visible: boolean;
}) {
  const { dismissModal, visible } = props;

  useEffect(() => {
    if (visible) {
      const timer = setTimeout(dismissModal, 3000);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [dismissModal, visible]);

  return (
    <div
      data-testid="thank-you-stage"
      className={sharedStyles['visibility-transition']}
      data-visible={visible || null}
    >
      <TransparentButton
        className={styles['thank-you-stage-button']}
        ariaLabel="Dismiss modal"
        onClick={dismissModal}
      >
        <X className={styles['x-icon']} />
        <img src="/img/rating/box_thank_you.svg" alt="Celebratory box" />
        <Heading
          className={styles['thank-you-stage-heading-text']}
          variant="H1Alt"
          as="span"
        >
          Thank you for your feedback!
        </Heading>
        <Paragraph
          className={styles['thank-you-stage-body-text']}
          variant="lead"
          as="span"
        >
          The more we learn about what you like,
          <br />
          the better your deliveries get.
        </Paragraph>
      </TransparentButton>
    </div>
  );
}
